// Central place to define application-specific terminology

export const terminology = {
  client: { // This key represents the concept originally known as 'Client'
    singular: "Supplier",
    plural: "Suppliers",
    // Add other related terms if needed, e.g.,
    // sectionTitle: "Supplier Information",
    // nameLabel: "Supplier Name",
  },
  household: { // This key represents the concept originally known as 'Household'
    singular: "Client",
    plural: "Clients",
    // Add other related terms if needed
  },
  jobNotes: { // This key represents the concept of notes for a job
    title: "Job Notes", // Default title, can be changed as needed
    // Add other related terms if needed, e.g.,
    // inputPlaceholder: "Enter job notes here...",
  },
  // Add other terms here as needed, e.g., job, etc.
};
